/**
 * @typedef DataBlockChunk
 */
export class DataBlockChunk {
  /**
   * @param {String} label
   * @param {String} value
   */
  constructor(label, value) {
    if (!label) throw new Error('Label must be specified');

    this.label = label;
    this.value = value || '-';
  }
}

export class DataBlock {
  /**
   *
   * @param {String} heading
   * @param {Array<DataBlockChunk>} chunks
   */
  constructor(heading, dataChunks) {
    if (!heading) throw new Error('heading must be specified');
    if (!dataChunks) throw new Error('Cannot create a new DataBlock');
    this.heading = heading;
    this.dataChunks = dataChunks;
  }
}

export class TableData {
  /**
   * @param {Array<String>} headings
   * @param {Array<Array<String>>} tableData
   */
  constructor(headings, tableData) {
    if (!headings) throw new Error('headings must be specified');
    if (!tableData) throw new Error('Cannot create a new Table without data');

    this.headings = headings;
    this.tableData = tableData;
  }
}
